<template>
  <div class="dj-layout">
    <dj-header>
      <ul class="d-flex flex-center l-s-n">
        <li :class="['nav-item transition', $route.path.startsWith('/console') && 'active']">
          <router-link to="/console">课程</router-link>
        </li>
      </ul>
      <div slot="right" class="user-info" @mouseenter="onmouseenter" @mouseleave="onmouseleave">
        <img class="avatar" :src="userInfo.headImage">
        <span>{{ userInfo.nickName }}</span>
        <transition>
          <div class="user-info-dropmenu" v-show="showpanel">
            <div class="user-info-dropmenu-item transition" @click="$router.push('/user')">
              <Icon type="ios-person-outline" style="font-size: 1rem" />我的
            </div>
            <div class="user-info-dropmenu-item transition" @click="logout">
              <Icon type="ios-log-out" />退出
            </div>
          </div>
        </transition>
      </div>
    </dj-header>
    <main class="dj-main bg-gray">
      <router-view></router-view>
    </main>
    <dj-footer></dj-footer>
    <BackTop>
      <Icon type="ios-arrow-dropup-circle" />
    </BackTop>
  </div>
</template>

<script>
import djHeader from './header'
import djFooter from './footer'
export default {
  name: 'djLayout',
  components: { djHeader, djFooter },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {}
    }
  },
  data() {
    return {
      showpanel: false
    }
  },
  methods: {
    onmouseenter() {
      this.showpanel = true
    },
    onmouseleave() {
      this.showpanel = false
    },
    logout() {
      this._r.post('sys/logout', undefined, {
        headers: {
          token: localStorage.getItem('token')
        }
      }).then(res => {
        // console.log(res, '退出登录')
        if (res.code === 0) {
          // 退出登录成功
          this.$router.push('/')
          this.$store.commit('removeToken')
          this.$store.commit('removeUserInfo')
        }
      })
    },
  }
}
</script>

<style lang="scss">
.dj-header {
  .user-info {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 0 1rem;
    position: relative;
    .user-info-dropmenu {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%;
      line-height: 1;
      background-color: #ffffff;
      box-shadow: 0 0 8px 0 rgba($color: #000000, $alpha: 0.1);
      border-radius: 4px;
      .user-info-dropmenu-item {
        padding: 0.7rem 0.5rem;
        margin-top: 2px;
        &:hover {
          background-color: #e8e2db;
        }
        & + .user-info-dropmenu-item {
          border-top: 1px solid rgba($color: #000000, $alpha: 0.1);
        }
      }
    }
  }
  img.avatar {
    width: 3rem;
    height: 3rem;
    border-radius: 0.3rem;
    vertical-align: top;
    margin-right: 0.4rem;
  }
}
</style>